import styles from "./AdminLogin.module.css";
import backgroundImage from "../../../assets/images/background.jpg";
import { checkSession, login } from "./AdminLoginApi";
import { useAppDispatch } from "../../../config/hooks";
import { useEffect } from "react";

const AdminLogin = () => {
  const dispatch = useAppDispatch();
  const bgStyle = {
    background: `lightgray url(${backgroundImage}) 50% / cover no-repeat`,
    display: "flex",
    FlexDirection: "column",
    minHeight: "100vh",
    alignItems: "stretch",
  };

  const handleLoginOnClick = (event: React.MouseEvent<HTMLFormElement>) => {
    event.preventDefault();
    const usernameInput = document.getElementById(
      "username"
    ) as HTMLInputElement;
    const passwordInput = document.getElementById(
      "password"
    ) as HTMLInputElement;
    if (!usernameInput || !passwordInput) return;
    const username = usernameInput.value;
    const password = passwordInput.value;
    dispatch(
      login({
        usernameEmail: username,
        password: password,
      })
    );
  };

  // useEffect(() => {
  //   Promise.all([dispatch(checkSession())]);
  // }, []);

  return (
    <div className={styles.Page} style={bgStyle}>
      <div className={styles.PageContainer}>
        <div className={styles.Container}>
          <div
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <p style={{ fontWeight: 700, fontSize: 18 }}>Admin Login</p>
          </div>

          <form onSubmit={handleLoginOnClick}>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <label htmlFor="username">Username</label>
              <input
                id="username"
                name="username"
                style={{
                  width: "calc(100% - 22px)",
                  height: "32px",
                  padding: "0 8px 0 12px",
                  border: "1px solid black",
                  borderRadius: "4px",
                  marginTop: 2,
                  marginBottom: 2,
                }}
              />
              <br />

              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                style={{
                  width: "calc(100% - 22px)",
                  height: "32px",
                  padding: "0 8px 0 12px",
                  border: "1px solid black",
                  borderRadius: "4px",
                  marginTop: 2,
                }}
              />

              <button type="submit" className={styles.Button}>
                Login as Admin
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
